<template>
    <div>
        <a class="btn btn-primary btn-block btn-raised" href="#/goals/create/" target="_blank">
            <span class="hidden-xs">{{ $t(`goals.list.btnCreate`) }}</span>
        </a>

        <hr />

        <div v-show="goals.length === 0">
            <l-no-data
                :text="
                    $t(`profile.goals.emptyVisitor`, {
                        firstname: revieweeUser.firstname,
                    })
                "
                icon="/img/icons/goals.png"
            />
        </div>

        <div v-for="goal in goals" :key="goal._id">
            <l-goal-list-item-short :goal="goal" :can-edit-k-rs="false"></l-goal-list-item-short>
        </div>
    </div>
</template>

<script>
import LNoData from "@/components/LNoData";
import LGoalListItemShort from "@/components/LGoalListItemShort";

export default {
    components: {
        LNoData,
        LGoalListItemShort,
    },
    props: {
        goals: {
            type: Array,
            required: true,
        },
        revieweeUser: {
            type: Object,
            required: true,
        },
    },
};
</script>
